import gql from 'graphql-tag'

export const GET_WATCHER_LIST_QUERY = gql`
  query watcher_list {
    watcher_list @rest(type: "WatcherList", path: "/watcher-list") {
      id
      name
      query
      condition
      definition
      last_updated_by
      updated_at
      entity_ids
      entity_type_ids
      interval
      status
      alert
      triggered_at
      result
    }
  }
`
